import type { FilterOption } from "./types";

export const DEMO_ANALYTICS_GROUP_ID = 270;
export const DEMO_ANALYTICS_OBJECT_VALUE = "__demo_analytics_object__";
export const DEMO_ANALYTICS_OBJECT_LABEL = "Демо Объект размещения";

export const DEMO_ANALYTICS_OBJECT_OPTION: FilterOption = {
  label: DEMO_ANALYTICS_OBJECT_LABEL,
  value: DEMO_ANALYTICS_OBJECT_VALUE,
};
